import React from "react";
import ReactDOM from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import App from "./App";
import "./i18n";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store";
import { ConfigProvider, theme } from "antd";
import buddhistEra from 'dayjs/plugin/buddhistEra';
import dayjs from "dayjs";



const root = ReactDOM.createRoot(document.getElementById("root"));
const { getDesignToken, useToken } = theme;
dayjs.extend(buddhistEra);
root.render(
  <React.StrictMode>
    <ReduxProvider store={store}>
      <App />
    </ReduxProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
